'use client'

import type { UseEmbeddedScriptProps } from '@pearlconvert/ui/components/embedded-script/embedded-script.types'

import { useEffect, useRef } from 'react'

export const useEmbeddedScript = ({ code }: UseEmbeddedScriptProps) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    container.innerHTML = code

    // Extract and execute scripts
    const scripts = container.querySelectorAll('script')
    const newScripts: HTMLScriptElement[] = []

    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script')

      // Copy attributes
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value)
      })

      // Copy script content
      newScript.textContent = oldScript.textContent

      // Replace old script with new one to trigger execution
      oldScript.parentNode?.replaceChild(newScript, oldScript)
      newScripts.push(newScript)
    })

    return () => {
      newScripts.forEach((script) => {
        script.remove()
      })
    }
  }, [code])

  return { containerRef }
}
